import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Station } from '../../../../../../client/model/station';

@Component({
  selector: 'app-sac-station-tablet',
  templateUrl: './sac-station-tablet.component.html',
  styleUrls: ['./sac-station-tablet.component.scss']
})
export class SACStationTabletComponent implements OnInit, OnDestroy {

  @Input() station: Station;

  constructor(
  ) { }

  ngOnInit(): void {

  }

  ngOnDestroy() {

  }

}
